/* eslint-disable react/no-danger */
import React from 'react';

import { SameFinishPerformanceBannerData } from './models';

import './SameFinishPerformanceBanner.scss';

interface SameFinishPerformanceBannerProps {
  data?: SameFinishPerformanceBannerData;
}

const SameFinishPerformanceBanner = ({ data }: SameFinishPerformanceBannerProps) => {
  const {
    bgImageMobile,
    bgImageDesktop,
    bgTearPaperMobile,
    bgTearPaperDesktop,
    finishLogo,
    headingTitle,
    headingSubtitle,
    fgImageMobile,
    fgImageDesktop,
  } = data || {};

  return (
    <section
      className="same-finish-performance-banner"
      style={
        {
          '--bg-image-desktop': `url(${bgImageDesktop?.url ?? ''})`,
          '--bg-image-mobile': `url(${bgImageMobile?.url || bgImageDesktop?.url || ''})`,
        } as React.CSSProperties
      }
    >
      <div
        className="heading-section"
        style={
          {
            '--bg-heading-section-desktop': `url(${bgTearPaperDesktop?.url ?? ''})`,
            '--bg-heading-section-mobile': `url(${
              bgTearPaperMobile?.url || bgTearPaperDesktop?.url || ''
            })`,
          } as React.CSSProperties
        }
      >
        {finishLogo && <img src={finishLogo.url} alt="Finish logo" />}
        {headingTitle && <h2>{headingTitle}</h2>}
        {headingSubtitle && <p dangerouslySetInnerHTML={{ __html: headingSubtitle }} />}
      </div>

      {(fgImageMobile || fgImageDesktop) && (
        <div className="main-image-container">
          <img className="main-image-mobile" src={fgImageMobile?.url} alt="Finish products range" />
          <img
            className="main-image-desktop"
            src={fgImageDesktop?.url}
            alt="Finish products range"
          />
        </div>
      )}
    </section>
  );
};

SameFinishPerformanceBanner.displayName = 'SameFinishPerformanceBanner';
export default SameFinishPerformanceBanner;
